import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-hc-timeseries-pivot",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "dimension",
    min: 1,
    types: ["Number", "Boolean", "String"],
  },

  dataFetching: {
    live: false,
    history: true,
  },

  dataExplorer: {
    title: "highcharts:explorer.timeseriespivot.title",
    description: "highcharts:explorer.timeseriespivot.description",
    icon: "fa:chart-line",
    config: {
      interaction_zoom_x: true,
      interaction_legend: true,
      interaction_tooltips: true,
    },
  },

  presets: [
    {
      label: "highcharts:explorer.timeseriespivot.title",
      description: "highcharts:explorer.timeseriespivot.description",
      tags: ["pivot"],
      imageLink: async () => (await import("./res_890")).default,
      layout: [6, 24] as [number, number],
      widget: {
        config: {
          interaction_minmax: false,
          interaction_minimap: false,
          interaction_tooltips: true,
          interaction_zoom_x: true,
          interaction_legend: true,
          _history: {
            historyType: "relative",
            value: 1,
            unit: "week",
          },
          values: ["sum", "minute"],
          rows: [],
          cols: [],
        },
      },
    },
  ],
});
